import { z } from "zod";
import { ValidationError } from "../errors/ValidationError";
import { dispatchValidationError } from "../errors/errorDispatcher";

const positiveIntSchema = z
  .union([z.number().int().positive(), z.string().regex(/^\d+$/)])
  .transform((v) => (typeof v === "string" ? Number(v) : v))
  .refine((v) => Number.isInteger(v) && v > 0, { message: "must be a positive integer" });

const booleanSchema = z.boolean();

export const metodiPagamentiRequestSchema = z.object({
  idVendor: positiveIntSchema,
  token: z.string().optional().nullable(),
});

export const associaMetodiPagamentoRequestSchema = z.object({
  idVendor: positiveIntSchema,
  listaMetodiPagamentoDaAssociare: z.array(
    z.object({
      idMetodoPagamento: positiveIntSchema,
      associa: booleanSchema,
    })
  ),
  token: z.string().optional().nullable(),
});

export function validateMetodiPagamentiRequest({ idVendor, token }) {
  const parsed = metodiPagamentiRequestSchema.safeParse({ idVendor, token });
  if (!parsed.success) {
    const message = `Invalid metodiPagamenti payload: ${parsed.error.issues[0]?.message ?? "unknown error"}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

export function validateAssociaMetodiPagamentoRequest({
  idVendor,
  listaMetodiPagamentoDaAssociare,
  token,
}) {
  const parsed = associaMetodiPagamentoRequestSchema.safeParse({
    idVendor,
    listaMetodiPagamentoDaAssociare,
    token,
  });
  if (!parsed.success) {
    const message = `Invalid associaMetodiPagamento payload: ${parsed.error.issues[0]?.message ?? "unknown error"}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

